import { render } from "./CaregiverDetailView.vue?vue&type=template&id=576f1aa0&scoped=true"
import script from "./CaregiverDetailView.vue?vue&type=script&lang=js"
export * from "./CaregiverDetailView.vue?vue&type=script&lang=js"

import "./CaregiverDetailView.vue?vue&type=style&index=0&id=576f1aa0&lang=css"
import "./CaregiverDetailView.vue?vue&type=style&index=1&id=576f1aa0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576f1aa0"]])

export default __exports__